
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { Icon } from '@mg/micro/vue2'
import BasicTitle from '@mg/web-components/Base/Typography/BasicTitle'
import { TranslateResult } from 'vue-i18n'
import FlashMessageBox from '@mg/web-components/Atoms/FlashMessageBox'
import { FlashMessage } from '@mg/web-components/Atoms/FlashMessageBox/types'
import { PropType } from 'vue'

export const DONT_HIDE_MESSAGE = 0

@Component<PageTitle>({
  components: {
    FlashMessageBox,
    Icon,
    BasicTitle,
  },
})
export default class PageTitle extends Vue {
  @Prop({ type: Number, default: 2 }) level!: number
  @Prop({ type: String as PropType<TranslateResult>, required: true })
  title!: TranslateResult

  @Prop({ type: String as PropType<TranslateResult>, required: false })
  backTitle?: TranslateResult

  @Prop({ type: String as PropType<TranslateResult>, required: false })
  errorMessage?: TranslateResult

  @Prop({ type: String as PropType<TranslateResult>, required: false })
  errorMessageSecond?: TranslateResult

  @Prop({ type: String as PropType<TranslateResult>, required: false })
  successMessage?: TranslateResult

  @Prop({ type: Boolean, default: true })
  showMessageAsToasts!: boolean

  @Emit()
  goBack() {}

  get showButtons(): boolean {
    return !!this.backTitle
  }

  get successMessageToast(): FlashMessage | null {
    if (this.successMessage) {
      const notification = this.$toaster.createSuccessMessage(
        this.successMessage,
        undefined,
        this.showMessageAsToasts ? undefined : DONT_HIDE_MESSAGE
      )
      notification.isToast = this.showMessageAsToasts
      return notification
    }
    return null
  }

  get errorMessageToast(): FlashMessage | null {
    if (this.errorMessage) {
      const notification = this.$toaster.createErrorMessage(
        this.errorMessage,
        undefined,
        this.showMessageAsToasts ? undefined : DONT_HIDE_MESSAGE
      )
      notification.isToast = this.showMessageAsToasts
      return notification
    }
    return null
  }

  get errorMessageSecondToast(): FlashMessage | null {
    if (this.errorMessageSecond) {
      const notification = this.$toaster.createErrorMessage(
        this.errorMessageSecond
      )
      notification.isToast = this.showMessageAsToasts
      return notification
    }
    return null
  }
}
